import React from "react";
import { MemoryRouter, Route, Routes, useLocation } from "react-router-dom";

import DetailPageTabs from "./DetailPageTabs";

const Panel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="rounded-md border border-gray-200 p-4 text-sm text-gray-700">{children}</div>
);

const CurrentPath: React.FC = () => {
	const { pathname } = useLocation();
	return (
		<p className="text-xs text-gray-500">
			Current route: <code>{pathname}</code>
		</p>
	);
};

const Inner: React.FC = () => (
	<div className="space-y-3">
		<CurrentPath />
		<DetailPageTabs
			skipTranslation
			actions={[
				{ label: "Lägg till användare", onClick: () => alert("Add user") },
				{
					label: "Avaktivera",
					danger: true,
					dividerBefore: true,
					onClick: () => alert("Deactivate"),
				},
			]}
			tabs={[
				{ route: "profile", label: "Profil", content: <Panel>Customer profile</Panel> },
				{ route: "jobs", label: "Uppdrag", content: <Panel>Customer jobs</Panel> },
				{
					route: "invoice-details",
					label: "Fakturainformation",
					content: <Panel>Invoice details</Panel>,
				},
				{
					route: "contract-and-prices",
					label: "Avtal & priser",
					content: <Panel>Contract & prices</Panel>,
				},
				{ route: "users", label: "Användare", content: <Panel>Customer users</Panel> },
			]}
		/>
	</div>
);

/**
 * Example for {@link DetailPageTabs} — the standard, "styled for this purpose"
 * detail-page tab bar (white rounded bar, rounded active highlight, optional
 * "..." overflow menu) shared across the customer / consultant / job detail
 * pages. Rendered inside a {@link MemoryRouter} so navigation stays contained.
 */
const DetailPageTabsExample: React.FC = () => {
	return (
		<div className="max-w-3xl space-y-4 p-6">
			<div>
				<h2 className="mb-2 text-xl font-bold">DetailPageTabs</h2>
				<p className="text-sm text-gray-600">
					The detail-page preset of <code>RouteTabs</code> — a white, bordered, rounded tab bar with
					a rounded highlight on the active tab and an optional <code>"..."</code> actions menu.
					Pass <code>tabs</code> and (optionally) <code>actions</code>; everything else is baked in.
				</p>
			</div>

			<MemoryRouter initialEntries={["/profile"]}>
				<Routes>
					<Route path="/*" element={<Inner />} />
				</Routes>
			</MemoryRouter>
		</div>
	);
};

export default DetailPageTabsExample;
